<template>
  <div>
    <el-tabs v-model="activeName">
<!--      <el-tab-pane name="LegalHousePlanUnit" label="项目自催计划">-->
<!--        <LegalHousePlanUnit v-if="activeName==='LegalHousePlanUnit'" :urge_type="5" :show_btn_type="[2,3,4,5]" />-->
<!--      </el-tab-pane>-->
<!--      <el-tab-pane name="LegalHousePlanTemp" label="互转计划">-->
<!--        <LegalHousePlanUnitEditor v-if="activeName==='LegalHousePlanTemp'" :urge_type="5" :show_btn_type="[2,3,4,5]" />-->
<!--      </el-tab-pane>-->

      <el-tab-pane name="LossLegalHousePlan" label="1年以上欠费">
        <template slot="label">
          <span>
            1年以上欠费
            <el-badge :value="(lossHouseCount)" ></el-badge>
          </span>
        </template>
        <LossLegalHousePlan @onAdd="handleAdd" v-if="activeName==='LossLegalHousePlan'" :show-age-type="[5]" />
      </el-tab-pane>

      <el-tab-pane name="LegalHousePlanTemp2" label="项目自催">
        <template slot="label">
          <span>
            项目自催
            <el-badge :value="(legal_house_obj.type_5_count)" ></el-badge>
          </span>
        </template>
        <!--        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp2'" :age_type_ids="[3,4]" :is_show_flow="true" :use_flow="[1]" :is_show_sync="true" />-->
        <LegalHousePlan2 v-if="activeName==='LegalHousePlanTemp2'" :urge_type="5" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp5" label="项目诉讼">
        <template slot="label">
          <span>
            项目诉讼
            <el-badge :value="(legal_house_obj.type_2_count)" ></el-badge>
          </span>
        </template>
        <!--        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp5'" :age_type_ids="[3,4]" :is_show_flow="true" :default_urge_type="2"  :use_flow="[1]" :is_show_sync="false" />-->
        <LegalHousePlan2 v-if="activeName==='LegalHousePlanTemp5'" :urge_type="2" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp4" label="第三方诉讼">
        <template slot="label">
          <span>
            第三方诉讼
            <el-badge :value="(legal_house_obj.type_4_count)" ></el-badge>
          </span>
        </template>
        <!--        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp4'" :age_type_ids="[3,4]" :is_show_flow="true" :default_urge_type="4" :use_flow="[1]" :is_show_sync="false" />-->
        <LegalHousePlan2 v-if="activeName==='LegalHousePlanTemp4'" :urge_type="4" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp3" label="第三方管理">
        <template slot="label">
          <span>
            第三方管理
            <el-badge :value="(legal_house_obj.type_3_count)" ></el-badge>
          </span>
        </template>
        <!--        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp3'" :age_type_ids="[3,4]" :is_show_flow="true" :default_urge_type="3" :use_flow="[1]" :is_show_sync="false" />-->
        <LegalHousePlan2 v-if="activeName==='LegalHousePlanTemp3'" :urge_type="3" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp6" label="未做计划欠费">
        <template slot="label">
          <span>
            未做计划欠费
            <el-badge :value="(notPlanHouseCount)" ></el-badge>
          </span>
        </template>
        <LossLegalHousePlan2 @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp6'" :isNotPlan="true" :show-age-type="[5]"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LossLegalHousePlan from "./LossLegalHousePlan";
import LegalHousePlanTemp from "./LegalHousePlanTemp";
import LegalHousePlanTempExcel from "./LegalHousePlanTempExcel";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
import LegalHousePlan from "./LegalHousePlan";
import LegalHousePlanUnit from "./LegalHousePlanUnit";
import LegalHousePlanUnitEditor from "./LegalHousePlanUnitEditor";
import LegalHousePlan2 from "./LegalHousePlan2";
import LossLegalHousePlan2 from "./LossLegalHousePlan2";
export default {
  name: "LegalLitigationLayout",
  inject:['where','reginWhere'],
  components: {
    LossLegalHousePlan2,
    LegalHousePlan2,
    LegalHousePlanUnitEditor,
    LegalHousePlanUnit, LegalHousePlan, LegalHousePlanTempExcel,LegalHousePlanTemp, LossLegalHousePlan},
  data() {
    return {
      activeName: "LegalHousePlanTemp2",
      legal_house_obj: {
        type_1_1_count:0,
        type_1_2_count:0,
        type_2_3_count:0,
        type_2_4_count:0,
        type_3_3_count:0,
        type_3_4_count:0,
        type_4_3_count:0,
        type_4_4_count:0,
        type_5_3_count:0,
        type_5_4_count:0,

        h_type_current_1_count:0,
        h_type_current_1_money:0,
        h_type_current_2_count:0,
        h_type_current_2_money:0,
        h_type_current_3_count:0,
        h_type_current_3_money:0,
        h_type_current_4_count:0,
        h_type_current_4_money:0,

        total: 0,
        type_1_count: 0,
        type_1_money: 0,
        type_2_count: 0,
        type_2_money: 0,
        type_3_count: 0,
        type_3_money: 0,
        type_4_count: 0,
        type_4_money: 0,
        type_5_count: 0,
        type_5_money: 0,
        loss_total: 0
      },
    };
  },
  mounted() {
    const that=this;
    CommonHelp.debounce(function () {
      that.handleAdd();
    },500,that)
  },
  activated() {
    const that=this;
    CommonHelp.debounce(function () {
      that.handleAdd();
    },500,that)
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("legalHouse/houseLegalCountObject",where,res=>{
        console.log(res.data)
        let keys = Object.keys(res.data);
        keys.forEach(item=>{
          res.data[item]=(res.data[item]||0)*1;
        })
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_ids":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
  },
  computed: {
    lossHouseCount(){
      return this.legal_house_obj.h_type_current_3_count+this.legal_house_obj.h_type_current_4_count;
    },
    notPlanHouseCount(){
      return this.lossHouseCount-(this.legal_house_obj.type_5_count+this.legal_house_obj.type_2_count+this.legal_house_obj.type_4_count+this.legal_house_obj.type_3_count);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalLitigationLayout.vue